import React from "react";
import Head from "next/head";
import { DefaultSeo, NextSeo } from "next-seo";
import type { NextSeoProps } from "next-seo/lib/types";

import { SITE_CONFIG } from "@src/config/site.config";

export const PageHead: React.FunctionComponent<{ pageSeo?: NextSeoProps }> = ({ pageSeo }) => {
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <DefaultSeo
        titleTemplate={`%s | ${SITE_CONFIG.productName}`}
        defaultTitle={SITE_CONFIG.productName}
        description={SITE_CONFIG.description}
        openGraph={{
          type: "website",
          locale: "en_US",
          url: SITE_CONFIG.domain,
          site_name: SITE_CONFIG.productName,
          description: SITE_CONFIG.description,
          images: [
            {
              url: `${SITE_CONFIG.domain}${SITE_CONFIG.ogImage}`,
              width: 1200,
              height: 630,
              alt: `${SITE_CONFIG.productName} Cover Image`
            }
          ]
        }}
        twitter={{
          handle: SITE_CONFIG.twitterHandle,
          site: SITE_CONFIG.twitterHandle,
          cardType: "summary_large_image"
        }}
      />

      <NextSeo {...pageSeo} />
    </>
  );
};
